import { SEO } from './useSeo';

export type Crumb = { name: string; path: string };

export const breadcrumbJsonLd = (crumbs: Crumb[]): Record<string, unknown> => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: crumbs.map((c, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: c.name,
    item: `${SEO.SITE_URL}${c.path.startsWith('/') ? '' : '/'}${c.path}`,
  })),
});
